import { Component, Input } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { RedirectExternalPageSelectedBank } from '@modules/redirect-to-external-bank/redirect-to-external-bank.component';
import { TranslateModule } from '@ngx-translate/core';
import { CloseAuthenticationTabPopinComponent } from '@shared/components/close-authentication-tab-popin/close-authentication-tab-popin.component';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-redirect-to-external-bank-wait',
  templateUrl: './redirect-to-external-bank-wait.component.html',
  standalone: true,
  imports: [TranslateModule, CloseAuthenticationTabPopinComponent],
})
export class RedirectToExternalBankWaitComponent {
  constructor(private readonly tracker: TrackerService) {}

  @Input() selectedBank: RedirectExternalPageSelectedBank | undefined;
  showPopin = false;

  closeTab() {
    window.close();
  }

  closePopin() {
    this.showPopin = false;
  }

  askToCloseTab() {
    this.tracker.trackClick({
      taggingPage: 'REDIRECT_TO_EXTERNAL_BANK_WAIT',
      click: frenchi18n.close_tab,
    });
    this.showPopin = true;
  }
}
